{
  "de": {
    "constants": {
      "address": {
        "city": "Stadt",
        "country": "Land",
        "number": "Hausnummer",
        "street": "Straße",
        "zip": "Postleitzahl"
      },
      "crud": {
        "created_at": "Erstellt am",
        "deleted_at": "Gelöscht am",
        "updated_at": "Aktualisiert am"
      },
      "currencies": {
        "all": "Alle Währungen",
        "popular": "Beliebt"
      },
      "days": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
      "languages": {
        "de": "Deutsch",
        "el": "Griechisch",
        "en": "Englisch",
        "es": "Spanisch",
        "fallback_info": "Das scheint in Ihrer Sprache nicht verfügbar zu sein. Wir verwenden stattdessen die vorhandene {fallback_locale}-Übersetzung.",
        "fr": "Französisch",
        "it": "Italienisch",
        "nl": "Niederländisch",
        "pl": "Polnisch",
        "pt": "Portugiesisch"
      },
      "languages_short": {
        "de": "DE",
        "el": "EL",
        "en": "EN",
        "es": "ES",
        "fr": "FR",
        "it": "IT",
        "nl": "NL",
        "pl": "PL",
        "pt": "PT"
      },
      "measurements": {
        "imperial": "Imperial",
        "metric": "Metrisch",
        "surface": {
          "imperial": "Sq. ft",
          "metric": "m²",
          "null": ""
        }
      },
      "months": [
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
      ],
      "profile_statuses": {
        "active": "Aktiv",
        "added": "Noch nicht eingeladen",
        "blocked": "Deaktiviert",
        "discarded": "Gelöscht",
        "invited": "Eingeladen",
        "invited_at": "Eingeladen"
      },
      "profile_statuses_descriptive": {
        "active": "Zuletzt aktiv auf der Plattform: {session_ended_at}",
        "added": "Noch nicht eingeladen",
        "blocked": "Deaktiviert",
        "discarded": "Gelöscht",
        "invited": "Eingeladen, aber noch nicht registriert",
        "invited_at": "Eingeladen am {invited_at}. Noch nicht registriert"
      },
      "profile_titles": {
        "dr": "Dr.",
        "mr": "Herr",
        "mrs": "Frau",
        "professor": "Prof.",
        "sirmadam": "-"
      },
      "time_units": {
        "days": "Tage",
        "months": "Monate",
        "weeks": "Wochen"
      },
      "time_units_count": {
        "days": "kein Tag | Tag | Tage",
        "months": "kein Monat | Monat | Monate",
        "weeks": "keine Woche | Woche | Wochen"
      },
      "timezone_regions": {
        "Africa": "Afrika",
        "America": "Amerika",
        "Asia": "Asien",
        "Atlantic": "Atlantik",
        "Australia": "Australien",
        "Europe": "Europa",
        "Pacific": "Pazifik"
      },
      "timezones": {
        "Africa/Abidjan": "Afrika/Abidjan",
        "Africa/Cairo": "Afrika/Kairo",
        "Africa/Casablanca": "Afrika/Casablanca",
        "Africa/Johannesburg": "Afrika/Johannesburg",
        "Africa/Lagos": "Afrika/Lagos",
        "Africa/Nairobi": "Afrika/Nairobi",
        "America/Anchorage": "Amerika/Anchorage",
        "America/Bogota": "Amerika/Bogota",
        "America/Buenos_Aires": "Amerika/Buenos Aires",
        "America/Chicago": "Amerika/Chicago",
        "America/Denver": "Amerika/Denver",
        "America/Halifax": "Amerika/Halifax",
        "America/Lima": "Amerika/Lima",
        "America/Los_Angeles": "Amerika/Los Angeles",
        "America/Mexico_City": "Amerika/Mexiko-Stadt",
        "America/New_York": "Amerika/New York",
        "America/Phoenix": "Amerika/Phoenix",
        "America/Santiago": "Amerika/Santiago",
        "America/Sao_Paulo": "Amerika/São Paulo",
        "America/St_Johns": "Amerika/St. John's",
        "America/Toronto": "Amerika/Toronto",
        "America/Vancouver": "Amerika/Vancouver",
        "Asia/Bangkok": "Asien/Bangkok",
        "Asia/Colombo": "Asien/Colombo",
        "Asia/Dhaka": "Asien/Dhaka",
        "Asia/Dubai": "Asien/Dubai",
        "Asia/Ho_Chi_Minh": "Asien/Ho-Chi-Minh-Stadt",
        "Asia/Hong_Kong": "Asien/Hongkong",
        "Asia/Jakarta": "Asien/Jakarta",
        "Asia/Karachi": "Asien/Karachi",
        "Asia/Kolkata": "Asien/Kolkata",
        "Asia/Kuala_Lumpur": "Asien/Kuala Lumpur",
        "Asia/Makassar": "Asien/Makassar",
        "Asia/Manila": "Asien/Manila",
        "Asia/Riyadh": "Asien/Riad",
        "Asia/Seoul": "Asien/Seoul",
        "Asia/Shanghai": "Asien/Shanghai",
        "Asia/Singapore": "Asien/Singapur",
        "Asia/Taipei": "Asien/Taipeh",
        "Asia/Tehran": "Asien/Teheran",
        "Asia/Tokyo": "Asien/Tokio",
        "Atlantic/Reykjavik": "Atlantik/Reykjavik",
        "Australia/Adelaide": "Australien/Adelaide",
        "Australia/Brisbane": "Australien/Brisbane",
        "Australia/Darwin": "Australien/Darwin",
        "Australia/Hobart": "Australien/Hobart",
        "Australia/Melbourne": "Australien/Melbourne",
        "Australia/Perth": "Australien/Perth",
        "Australia/Sydney": "Australien/Sydney",
        "Europe/Amsterdam": "Europa/Amsterdam",
        "Europe/Athens": "Europa/Athen",
        "Europe/Belgrade": "Europa/Belgrad",
        "Europe/Berlin": "Europa/Berlin",
        "Europe/Brussels": "Europa/Brüssel",
        "Europe/Bucharest": "Europa/Bukarest",
        "Europe/Budapest": "Europa/Budapest",
        "Europe/Copenhagen": "Europa/Kopenhagen",
        "Europe/Dublin": "Europa/Dublin",
        "Europe/Helsinki": "Europa/Helsinki",
        "Europe/Istanbul": "Europa/Istanbul",
        "Europe/Lisbon": "Europa/Lissabon",
        "Europe/London": "Europa/London",
        "Europe/Madrid": "Europa/Madrid",
        "Europe/Moscow": "Europa/Moskau",
        "Europe/Oslo": "Europa/Oslo",
        "Europe/Paris": "Europa/Paris",
        "Europe/Prague": "Europa/Prag",
        "Europe/Rome": "Europa/Rom",
        "Europe/Stockholm": "Europa/Stockholm",
        "Europe/Vienna": "Europa/Wien",
        "Europe/Warsaw": "Europa/Warschau",
        "Europe/Zurich": "Europa/Zürich",
        "Pacific/Auckland": "Pazifik/Auckland",
        "Pacific/Fiji": "Pazifik/Fidschi",
        "Pacific/Honolulu": "Pazifik/Honolulu"
      },
      "wind_orientations": {
        "east": "Ost",
        "north": "Nord",
        "northeast": "Nordost",
        "northwest": "Nordwest",
        "select": "Ausrichtung wählen",
        "south": "Süd",
        "southeast": "Südost",
        "southwest": "Südwest",
        "west": "West"
      }
    }
  }
}
